export const DELIVERY_VOUCHERS_PERMISSIONS = {
  index: ['DELIVERY-VOUCHERS.INDEX'],
  export: ['DELIVERY-VOUCHERS.EXPORT'],
  getAllByInvoiceId: ['DELIVERY-VOUCHERS.GETALLBYINVOICEID'],
  download: ['DELIVERY-VOUCHERS.DOWNLOAD'],
  update: ['DELIVERY-VOUCHERS.UPDATE'],
  delete: ['DELIVERY-VOUCHERS.DELETE'],
};
